import { useEffect, useRef } from 'react'
import { Card } from 'react-bootstrap'

const LogViewer = ({ logs = [], onClearLogs }) => {
  const logContainerRef = useRef(null)

  // 自动滚动到底部
  useEffect(() => {
    if (logContainerRef.current) {
      logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight
    }
  }, [logs])

  if (logs.length === 0) return null

  return (
    <Card className="mb-4">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">执行日志</h5>
        {onClearLogs && (
          <button className="btn btn-sm btn-outline-secondary" onClick={onClearLogs}>
            清空日志
          </button>
        )}
      </Card.Header>
      <Card.Body>
        <div className="log-container" ref={logContainerRef}>
          {logs.map((log) => (
            <div key={log.id} className={`log-entry log-${log.type}`}>
              [{log.timestamp}] {log.message}
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  )
}

export default LogViewer
